// styles
import classnames from 'classnames/bind';
import CloseButton from 'components/Button/CloseButton';
// components
import Portal from 'components/Portal';
import T from 'prop-types';
import React, { useEffect, useState } from 'react';

import styles from './Modal.module.scss';

const cx = classnames.bind(styles);

const modalRoot = document.getElementById('modal-root');

const Modal = ({ isOpen, onClose, className, children }) => {
  const [modalOpen, setModalOpen] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      setModalOpen(true);
      return;
    }

    const to = setTimeout(() => setModalOpen(false), 200);

    return () => clearTimeout(to);
  }, [isOpen]);

  if (!modalOpen) return null;

  return (
    <Portal portalRoot={modalRoot}>
      <div className={cx('modal-overlay', { closing: !isOpen })}>
        <div className={styles.modalInner}>
          <div className={cx('modal-body', className)}>
            {!!onClose && <CloseButton variant="light" className={cx('close-button')} onClick={onClose} />}

            {children}
          </div>
        </div>
      </div>
    </Portal>
  );
};

Modal.propTypes = {
  isOpen: T.bool.isRequired,
  onClose: T.func,
  className: T.oneOfType([T.func, T.string]),
  children: T.oneOfType([T.func, T.string, T.node]),
};

export default Modal;
